// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3XvBx","itemTitle":"ClientEmergencyInfo_itemTitle__fOcEH","itemText":"ClientEmergencyInfo_itemText__3CjUL"};